module.exports = __webpack_public_path__ + "img/II-33.94a4a6fc.svg";